interface SchoolInfo {
  name?: string;
  telephone?: string;
  fullName?: string;
  phoneNumber?: string;
  address?: string;
}

const SchoolInfoMap = ({
  name,
  telephone,
  fullName,
  phoneNumber,
  address,
}: SchoolInfo) => {
  return (
    <div className="description">
      {name && (
        <p>
          <i className="fa-light fa-buildings"></i> {name}
          {telephone && " (" + telephone + ")"}
        </p>
      )}

      {fullName && (
        <p>
          <i className="fa-light fa-user"></i> {fullName}
          {phoneNumber && " (" + phoneNumber + ")"}
        </p>
      )}

      {address && (
        <p>
          <i className="fa-light fa-location-dot"></i> {address}
        </p>
      )}
    </div>
  );
};

export default SchoolInfoMap;
